<template>
  <div id="slide-report-form">
    <horizontal-field-layout
      label="期間"
      class="mb-8"
    >
      <select-field
        v-model="innerPeriod"
        name="期間"
        rules="required"
        :options="periodOptions"
        :searchable="false"
      />
    </horizontal-field-layout>
    <horizontal-field-layout
      label="カテゴリー"
      class="mb-8"
    >
      <select-field
        v-model="innerCategory"
        name="カテゴリー"
        rules="required"
        :options="categoryOptions"
        :searchable="false"
      />
    </horizontal-field-layout>
    <div class="mb-8">
      <p>スライドレポートで利用するカテゴリーを選択してください。</p>
      <ul>
        <li>・サブカテゴリー：Amazonにて設定される商品の最小単位カテゴリ（ブラウズノーズ）です。</li>
        <li>・出品者カテゴリー：Ubun BASEで設定する任意のカテゴリーです。商品ページにて設定できます。</li>
      </ul>
    </div>
    <horizontal-field-layout
      class="mb-8"
      label="フィルタページの追加"
    >
      <template
        v-for="(filter, i) in reportFilters"
        :key="`trend-filter-${i}`"
      >
        <div class="flex mb-3">
          <select-field
            v-model:model-value="filter.filterType"
            name="フィルタ"
            :options="filterTypeOptions"
            @update:model-value="onFilterChange(i, {
              filterType: $event,
            })"
          />
          <div class="mt-2 mx-3">
            is
          </div>
          <select-field
            v-model:model-value="filter.filterData"
            name="値"
            :placeholder="`${filterTypeOptions.find(o => o.value === filter.filterType).text}を選択`"
            :options="getFilterValueOptions(filter.filterType)"
            multiple
            full-width
            @update:model-value="onFilterChange(i, {
              filterData: $event,
            })"
          />
          <span
            class="feather-icon ml-3"
            @click="onDeleteFilterClick(i)"
          >
            <VueFeather
              type="trash"
              class="cursor-pointer"
            />
          </span>
        </div>
        <div class="flex items-center mb-3">
          <p class="mr-5">カテゴリー</p>
          <select-field
            v-model:model-value="filter.category"
            name="カテゴリー"
            rules="required"
            :options="categoryOptions"
            @update:model-value="onFilterChange(i, {
              category: $event,
            })"
          />
        </div>
        <vs-button
          v-if="i === reportFilters.length - 1 && reportFilters.length <= 2"
          :key="`add-trend-filter-${i}`"
          class="mt-4"
          icon="add"
          type="border"
          radius
          @click="onAddFilterClick"
        />
      </template>
      <vs-button
        v-if="reportFilters.length === 0"
        icon="add"
        type="border"
        radius
        @click="onAddFilterClick"
      />
    </horizontal-field-layout>
    <div>
      <p>フィルタページの追加を設定すると、Trendページが設定された項目でフィルタリングされた状態で追加されます。カテゴリーや商品単位での売上分析に活用してください。</p>
    </div>
    <horizontal-field-layout
      v-if="isMaker"
      label="お取引形態"
      class="mt-8"
    >
      <select-field
        v-model="innerTransactionForm"
        name="お取引形態"
        rules="required"
        :options="transactionFormOptions"
        :searchable="false"
      />
    </horizontal-field-layout>
  </div>
</template>

<script>
import SelectField from '@/components/fields/SelectField'
import HorizontalFieldLayout from '@/components/layouts/form/HorizontalFieldLayout'

export default {
  name: 'SlideReportForm',
  components: {
    HorizontalFieldLayout,
    SelectField
  },
  props: {
    period: {
      type: Number,
      default: 1
    },
    category: {
      type: Number,
      default: 1
    },
    transactionForm: {
      type: Number,
      default: 1
    },
    isMaker: {
      type: Boolean,
      default: false
    },
    periodValueOptions: {
      type: Object,
      default: () => {}
    },
    reportFilters: {
      type: Array,
      default: () => []
    },
    filterValueOptions: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:period', 'update:category', 'update:report-filters', 'update:transaction-form'],
  computed: {
    innerPeriod: {
      get () {
        return this.period
      },
      set (value) {
        this.$emit('update:period', value)
      }
    },
    innerCategory: {
      get () {
        return this.category
      },
      set (value) {
        this.$emit('update:category', value)
      }
    },
    innerTransactionForm: {
      get () {
        return this.transactionForm
      },
      set (value) {
        this.$emit('update:transaction-form', value)
      }
    },
    periodOptions () {
      if (!this.periodValueOptions.periods) {
        return [
          { value: 2, text: '今月' },
          { value: 1, text: '前月' }
        ]
      }
      return this.periodValueOptions.periods
    },
    filterTypeOptions () {
      return [
        { value: 1, text: 'サブカテゴリー' },
        { value: 2, text: '出品者カテゴリー1' },
        { value: 3, text: '出品者カテゴリー2' },
        { value: 4, text: '出品者カテゴリー3' },
        { value: 5, text: '出品者カテゴリー4' },
        { value: 6, text: '出品者カテゴリー5' },
        { value: 7, text: 'ASIN' },
        { value: 8, text: '親ASIN' },
        { value: 9, text: 'ブランド' }
      ]
    },
    categoryOptions () {
      return [
        { value: 1, text: 'サブカテゴリー' },
        { value: 2, text: '出品者カテゴリー1' },
        { value: 3, text: '出品者カテゴリー2' },
        { value: 4, text: '出品者カテゴリー3' },
        { value: 5, text: '出品者カテゴリー4' },
        { value: 6, text: '出品者カテゴリー5' }
      ]
    },
    transactionFormOptions () {
      return [
        { value: 1, text: 'メーカー' },
        { value: 2, text: 'お取引業者' }
      ]
    }
  },
  methods: {
    getFilterValueOptions (field) {
      if (field === 1) {
        // サブカテゴリー
        return this.filterValueOptions.subcategoryName.filter(item => item.subcategoryName !== null).map(item => ({
          text: item.subcategoryName,
          value: item.subcategoryName
        })) || []
      } else if (field === 2) {
        // 出品者カテゴリー
        return this.filterValueOptions.sellerCategory.filter(item => item.sellerCategory !== null).map(item => ({
          text: item.sellerCategory,
          value: item.sellerCategory
        })) || []
      } else if (field === 3) {
        // 出品者カテゴリー2
        return this.filterValueOptions.sellerCategory2.filter(item => item.sellerCategory2 !== null).map(item => ({
          text: item.sellerCategory2,
          value: item.sellerCategory2
        })) || []
      } else if (field === 4) {
        // 出品者カテゴリー3
        return this.filterValueOptions.sellerCategory3.filter(item => item.sellerCategory3 !== null).map(item => ({
          text: item.sellerCategory3,
          value: item.sellerCategory3
        })) || []
      } else if (field === 5) {
        // 出品者カテゴリー4
        return this.filterValueOptions.sellerCategory4.filter(item => item.sellerCategory4 !== null).map(item => ({
          text: item.sellerCategory4,
          value: item.sellerCategory4
        })) || []
      } else if (field === 6) {
        // 出品者カテゴリー5
        return this.filterValueOptions.sellerCategory5.filter(item => item.sellerCategory5 !== null).map(item => ({
          text: item.sellerCategory5,
          value: item.sellerCategory5
        })) || []
      } else if (field === 7) {
        // ASIN
        return this.filterValueOptions.asin.filter(item => item.asin !== null).map(item => ({
          text: item.asin,
          value: item.asin
        })) || []
      } else if (field === 8) {
        // 親ASIN
        return this.filterValueOptions.parentAsin.filter(item => item.parentAsin !== null).map(item => ({
          text: item.parentAsin,
          value: item.parentAsin
        })) || []
      } else if (field === 9) {
        // ブランド
        return this.filterValueOptions.brand.filter(item => item.brand !== null).map(item => ({
          text: item.brand,
          value: item.brand
        })) || []
      }
      return []
    },
    onFilterChange (index, value) {
      this.$emit('update:report-filters', [
        ...this.reportFilters.slice(0, index),
        {
          ...this.reportFilters[index],
          ...value
        },
        ...this.reportFilters.slice(index + 1)
      ])
    },
    onAddFilterClick () {
      if (this.reportFilters.length >= 3) {
        return
      }
      this.$emit('update:report-filters', [
        ...this.reportFilters,
        {
          filterType: 1,
          category: 1,
          filterData: []
        }
      ])
    },
    onDeleteFilterClick (index) {
      this.$emit('update:report-filters', [
        ...this.reportFilters.slice(0, index),
        ...this.reportFilters.slice(index + 1)
      ])
    }
  }
}
</script>

<style>
#slide-report-form .horizontal-field-layout {
  align-items: self-start;
}
#slide-report-form .horizontal-field-label {
  margin-top: 10px;
}
#slide-report-form .vs-button--icon {
  z-index: initial !important;
}
</style>
